import React, {Fragment, useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import CardContent from '@material-ui/core/CardContent';
import Fab from '@material-ui/core/Fab';

import SearchIcon from '@material-ui/icons/Search';
import DoneIcon from '@material-ui/icons/Done';
import PrintIcon from '@material-ui/icons/Print';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  avatarPrimary: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  avatarSecondary: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

export default function Results(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({
    text: ''
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerResults', props.match.params.cnp ? {cnp: props.match.params.cnp} : {})
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const filterData = item => true
      && (
           !!~item.surname.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.name.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.cnp.toLowerCase().indexOf(filter.text.toLowerCase())
      );

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Rezultate analize</Typography>
      {props.match.params.cnp
        ? <Typography variant='subtitle2'>Sunt afisate toate rezultatele analizelor pentru pacientul selectat.</Typography>
        : <Fragment>
            <Typography variant='subtitle2'>Sunt afisate doar rezultatele analizelor din ultima saptamana.</Typography>
            <Typography variant='subtitle2'>Pentru rezultate mai vechi, <Link to='/Patients'>cautati dupa pacient</Link>.</Typography>
          </Fragment>
      }
      <Typography variant='subtitle2'>Pentru recoltarile care sunt in lucru la laborator, accesati sectiunea <Link to='/Receptions'>recoltari</Link>.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.length > 0 && !props.match.params.cnp &&
        <Grid container>
          <Grid item xs={12}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.length > 0 && data.filter(filterData).length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
      }

      {isLoaded &&
        <Grid container spacing={1} alignItems='stretch'>
          {data.filter(filterData).map(item =>
            <Grid key={item.id} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Card className={classes.card}>
                <CardHeader className={classes.cardHeader}
                  avatar={
                    <Avatar className={Boolean(parseInt(item.isReaded)) ? classes.avatarPrimary : classes.avatarSecondary}>
                      {Boolean(parseInt(item.isReaded))
                        ? <DoneIcon />
                        : <PrintIcon />
                      }
                    </Avatar>
                  }
                  action={
                    Boolean(parseInt(item.isValidated))
                      ? <IconButton color='primary'
                          onClick={() => window.open(`${props.url.download}?op=buletin_analize&id_receptie=${item.idReceptionSL}&idResellerReception=${item.id}&SID=${props.user.sessid}&variant=live`)}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      : null
                  }
                  title={`${item.surname} ${item.name}`}
                  subheader={`CNP ${item.cnp}`}
                />
                <CardContent className={classes.cardContent}>
                  <Typography color={Boolean(parseInt(item.isReaded)) ? 'primary' : 'secondary'}>
                    ID recoltare: {item.id} (buletin {Boolean(parseInt(item.isReaded)) ? 'descarcat' : 'nedescarcat'})
                  </Typography>
                  <Divider className={classes.divider} />
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1}}>Telefon:</Typography>
                    <Typography align='right' component='div'>{item.phone}</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1}}>Recoltat:</Typography>
                    <Typography align='right' component='div'>{item.createdBy} / {item.createdAt}</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1}}>Dat in lucru:</Typography>
                    <Typography align='right' component='div'>{item.receivedAt}</Typography>
                  </Box>
                  <Box style={{display: 'flex'}}>
                    <Typography color='textSecondary' style={{flexGrow: 1}}>Finalizat:</Typography>
                    <Typography align='right' component='div'>{item.validatedAt}</Typography>
                  </Box>
                  {Boolean(item.description) &&
                    <Fragment>
                      <Divider className={classes.divider} />
                      <Typography component='div' color='textSecondary' style={{whiteSpace: 'pre-wrap'}}>
                        Observatii:
                        <Typography color='textPrimary'>{Boolean(item.description) ? item.description : ''}</Typography>
                      </Typography>
                    </Fragment>
                  }
                  {Boolean(item.companySL) &&
                    <Fragment>
                      <Divider className={classes.divider} />
                      <Typography color='secondary'>Analize decontate de CAS</Typography>
                    </Fragment>
                  }
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerAddReception') &&
        <Link to={props.match.params.cnp ? `/AddReception/${props.match.params.cnp}` : '/AddReception'} className={classes.link}>
          <Fab variant='extended' className={classes.fab}>
            <AddIcon className={classes.fabIcon} />
            Adauga recoltare
          </Fab>
        </Link>
      }
    </Container>
  );
}